export default "__VITE_ASSET__BHR2o00c__"